module.exports = __webpack_public_path__ + "static/img/8bg_13.d42f4c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_13.png
// module id = 751
// module chunks = 1